import { Models } from '@rematch/core';

/* ENTITIES */
import {
  cooperatorEntity,
  storeName as cooperatorEntityStoreName,
} from './entities/cooperator.entity';
import { newsEntity, storeName as newsEntityStoreName } from './entities/news.entity';
import { facilityEntity, storeName as facilityEntityStoreName } from './entities/facility.entity';
import {
  promotionEntity,
  storeName as promotionEntityStoreName,
} from './entities/promotion.entity';
import { floorEntity, storeName as floorEntityStoreName } from './entities/floor.entity';
import {
  locationGroupEntity,
  storeName as locationGroupEntityStoreName,
} from './entities/locationGroup.entity';
import {
  mapLocationEntity,
  storeName as mapLocationEntityStoreName,
} from './entities/mapLocation.entity';
import { projectEntity, storeName as projectEntityStoreName } from './entities/project.entity';
import {
  projectChildItemEntity,
  storeName as projectChildItemEntityStoreName,
} from './entities/projectChildItem.entity';
import {
  projectItemEntity,
  storeName as projectItemEntityStoreName,
} from './entities/projectItem.entity';
import {
  templateCategoryEntity,
  storeName as templateCategoryEntityStoreName,
} from './entities/templateCategory.entity';
import { tourEntity, storeName as tourEntityStoreName } from './entities/tour.entity';
import {
  userContactEntity,
  storeName as userContactStoreName,
} from './entities/userContact.entity';
import { questionEntity, storeName as questionStoreName } from './entities/question.entity';
import {
  sitePlanPromotionsEntity,
  storeName as sitePlanPromotionsEntityStoreName,
} from './entities/sitePlanPromotions.entity';

/* MODELS */
import { aboutModel, storeName as aboutModelStoreName } from './models/about.model';
import { amenitiesModel, storeName as amenitiesModelStoreName } from './models/amenities.model';
import {
  amenitiesOverviewModel,
  storeName as amenitiesOverviewModelStoreName,
} from './models/amenitiesOverview.model';
import {
  homeProfileModel,
  storeName as homeProfileModelStoreName,
} from './models/homeProfile.model';
import { layoutModel, storeName as layoutModelStoreName } from './models/layout.model';
import { locationModel, storeName as locationModelStoreName } from './models/location.model';
import {
  locationOverviewModel,
  storeName as locationOverviewModelStoreName,
} from './models/location-overview.model';
import { projectModel, storeName as projectModelStoreName } from './models/project.model';
import { sitePlanModel, storeName as sitePlanModelStoreName } from './models/sitePlan.model';

export interface RootModel extends Models<RootModel> {
  /* ENTITIES */
  [cooperatorEntityStoreName]: typeof cooperatorEntity;
  [facilityEntityStoreName]: typeof facilityEntity;
  [floorEntityStoreName]: typeof floorEntity;
  [promotionEntityStoreName]: typeof promotionEntity;
  [locationGroupEntityStoreName]: typeof locationGroupEntity;
  [mapLocationEntityStoreName]: typeof mapLocationEntity;
  [newsEntityStoreName]: typeof newsEntity;
  [projectEntityStoreName]: typeof projectEntity;
  [projectChildItemEntityStoreName]: typeof projectChildItemEntity;
  [projectItemEntityStoreName]: typeof projectItemEntity;
  [templateCategoryEntityStoreName]: typeof templateCategoryEntity;
  [tourEntityStoreName]: typeof tourEntity;
  [sitePlanPromotionsEntityStoreName]: typeof sitePlanPromotionsEntity;
  [userContactStoreName]: typeof userContactEntity;
  [questionStoreName]: typeof questionEntity;

  /* MODELS */
  [aboutModelStoreName]: typeof aboutModel;
  [amenitiesModelStoreName]: typeof amenitiesModel;
  [amenitiesOverviewModelStoreName]: typeof amenitiesOverviewModel;
  [homeProfileModelStoreName]: typeof homeProfileModel;
  [layoutModelStoreName]: typeof layoutModel;
  [locationModelStoreName]: typeof locationModel;
  [locationOverviewModelStoreName]: typeof locationOverviewModel;
  [projectModelStoreName]: typeof projectModel;
  [sitePlanModelStoreName]: typeof sitePlanModel;
}

export const models: RootModel = {
  /* ENTITIES */
  [cooperatorEntityStoreName]: cooperatorEntity,
  [facilityEntityStoreName]: facilityEntity,
  [promotionEntityStoreName]: promotionEntity,
  [floorEntityStoreName]: floorEntity,
  [locationGroupEntityStoreName]: locationGroupEntity,
  [mapLocationEntityStoreName]: mapLocationEntity,
  [newsEntityStoreName]: newsEntity,
  [projectEntityStoreName]: projectEntity,
  [projectChildItemEntityStoreName]: projectChildItemEntity,
  [projectItemEntityStoreName]: projectItemEntity,
  [templateCategoryEntityStoreName]: templateCategoryEntity,
  [tourEntityStoreName]: tourEntity,
  [sitePlanPromotionsEntityStoreName]: sitePlanPromotionsEntity,
  [userContactStoreName]: userContactEntity,
  [questionStoreName]: questionEntity,

  /* MODELS */
  [aboutModelStoreName]: aboutModel,
  [amenitiesModelStoreName]: amenitiesModel,
  [amenitiesOverviewModelStoreName]: amenitiesOverviewModel,
  [homeProfileModelStoreName]: homeProfileModel,
  [layoutModelStoreName]: layoutModel,
  [locationModelStoreName]: locationModel,
  [projectModelStoreName]: projectModel,
  [sitePlanModelStoreName]: sitePlanModel,
  [locationOverviewModelStoreName]: locationOverviewModel,
};
